import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import { requiredFieldError, requiredString } from '../helper';

const requiredField = z
  .boolean({ required_error: requiredFieldError() })
  .refine(value => !!value, { message: requiredFieldError() });

export const eligibilitySchema = z.discriminatedUnion('financialProductId', [
  z.object({
    financialProductId: z.literal(FINANCIAL_PRODUCT.ACT_SFA),
    agreeToFinanceTerms: requiredField,
    agreeToCustomerDeclaration: requiredField,
  }),
  ...[FINANCIAL_PRODUCT.SME].map(product =>
    z.object({
      financialProductId: z.literal(product),
      agreeToFinanceTerms: requiredField,
      agreeToCustomerDeclaration: requiredField,
    }),
  ),
  ...[
    FINANCIAL_PRODUCT.BGL,
    FINANCIAL_PRODUCT.BPL,
    FINANCIAL_PRODUCT.FLEX,
    FINANCIAL_PRODUCT.ELECTRIFY_2515,
    FINANCIAL_PRODUCT.HEUF_LOAN,
  ].map(product =>
    z.object({
      financialProductId: z.literal(product),
      agreeToFinanceTerms: requiredField,
      agreeToPrivacyTerms: requiredField,
      agreeToCustomerDeclaration: requiredField,
    }),
  ),
  ...[
    FINANCIAL_PRODUCT.BRIGHTE_PAY,
    FINANCIAL_PRODUCT.ACT_SLIP,
    FINANCIAL_PRODUCT.ACT_SHS,
    FINANCIAL_PRODUCT.TAS_ESLS,
  ].map(product =>
    z.object({
      financialProductId: z.literal(product),
      agreeToFinanceTerms: requiredField,
      agreeToPrivacyTerms: requiredField,
      agreeToCustomerDeclaration: requiredField,
      applicant: z.object({
        unsolicitedSaleOptions: requiredString(),
      }),
    }),
  ),
]);

export type EligibilityType = z.infer<typeof eligibilitySchema> & {
  applicant: { unsolicitedSaleOptions?: string };
  agreeToFinanceTerms?: boolean;
  agreeToPrivacyTerms?: boolean;
  agreeToCustomerDeclaration?: boolean;
};
